import type { TraditionalDoc, TraditionalWord } from "./doc";

export interface WordGroup {
  label: string;
  words: TraditionalWord[];
}

function group(
  words: TraditionalWord[],
  line: (w: TraditionalWord) => number,
  pos: (w: TraditionalWord) => number,
  prefix: string,
): WordGroup[] {
  const byLine = new Map<number, TraditionalWord[]>();
  for (const w of words) {
    const k = line(w);
    byLine.set(k, [...(byLine.get(k) ?? []), w]);
  }
  return Array.from(byLine.keys())
    .sort((a, b) => a - b)
    .map((k) => ({
      label: `${prefix} ${k + 1}`,
      words: [...byLine.get(k)!].sort((a, b) => pos(a) - pos(b)),
    }));
}

/** Lista da tela: horizontais por linha (ordenadas por x), verticais por coluna (por y). */
export function groupWords(doc: TraditionalDoc): {
  horizontais: WordGroup[];
  verticais: WordGroup[];
} {
  return {
    horizontais: group(
      doc.palavras.filter((w) => !w.direcao),
      (w) => w.y,
      (w) => w.x,
      "Linha",
    ),
    verticais: group(
      doc.palavras.filter((w) => w.direcao),
      (w) => w.x,
      (w) => w.y,
      "Coluna",
    ),
  };
}

function covers(w: TraditionalWord, x: number, y: number): boolean {
  const len = w.texto.length;
  return w.direcao
    ? w.x === x && y >= w.y && y < w.y + len
    : w.y === y && x >= w.x && x < w.x + len;
}

/** Palavras que passam pela casa (x, y). */
export function wordAt(
  doc: TraditionalDoc,
  x: number,
  y: number,
): { horizontal?: TraditionalWord; vertical?: TraditionalWord } {
  const out: { horizontal?: TraditionalWord; vertical?: TraditionalWord } = {};
  for (const w of doc.palavras) {
    if (!covers(w, x, y)) continue;
    if (w.direcao) out.vertical = w;
    else out.horizontal = w;
  }
  return out;
}
